import React, { useState } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Assignment } from '@material-ui/icons';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { wsFindBy } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import FilterArticle from 'hooks/FilterArticle';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};

const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Cód. proveedor', accessor: 'CardCode' },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Nombre categoría', accessor: 'category' },
  { Header: 'Nombre familia', accessor: 'family' },
  { Header: 'Cód. Producto', accessor: 'code' },
  { Header: 'Nombre producto', accessor: 'article' },
  { Header: 'List. precio', accessor: 'priceList' },
  { Header: 'Zona', accessor: 'zone' },
  { Header: 'Canal', accessor: 'canal' },
  { Header: 'Pre. compra', accessor: 'last_purchase_price' },
  { Header: 'Margen', accessor: 'unit_margin' },
  { Header: 'Margen Paq.', accessor: 'package_margin' },
  { Header: 'Precio Uni.', accessor: 'unit_price' },
  { Header: 'Precio Paq.', accessor: 'package_price' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Price(props) {
  const classes = useStyles();

  const [prices, setPrices] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listPrices(search) {
    setDataLoading(true);
    let response = await wsFindBy('logi/consult-price', search);
    setDataLoading(false);
    if (response.success) setPrices(response.data);
  }

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Consulta de Precios {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterArticle getFilter={listPrices} priceList zone canal />

            <ReactTable
              excelName="Precios"
              defaultWidth={2700}
              indexRow={[0, 1, 2, 3, 4, 5, 6, 15]}
              widthRow={[80, 150, 300, 250, 250, 150, 300, 5]}
              columns={columns}
              data={prices.map((priceL, i) => {
                return {
                  num: i + 1,
                  CardCode: priceL.CardCode,
                  CardName: priceL.CardName,
                  category: priceL.logi_category_description,
                  family: priceL.logi_family_description,
                  code: priceL.ItemCode,
                  article: priceL.ItemName,
                  priceList: priceL.ListName,
                  zone: priceL.base_zone_description,
                  canal: priceL.base_canal_description,
                  last_purchase_price:
                    priceL.last_purchase_price === null
                      ? 'No hay ult. precio'
                      : priceL.last_purchase_price,
                  unit_margin: priceL.unit_margin === null ? '0' : priceL.unit_margin,
                  package_margin: priceL.package_margin === null ? '0' : priceL.package_margin,
                  unit_price: priceL.unit_price,
                  package_price: priceL.package_price,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});